import { Button } from "@hero-app/components/ui/button";
import { InfoIcon } from "@hero-app/components/ui/icons/nav-icons";
import { cn } from "@hero-app/lib/utils";

export type ReferralCardSize = "sm" | "md" | "lg";

const REFERRAL_CARD_SIZE: Record<
  ReferralCardSize,
  { box: string; gap: string; row: string; icon: string; text: string }
> = {
  sm: { box: "p-1.5", gap: "gap-1", row: "mb-1.5", icon: "size-2", text: "text-[9px] leading-[11px]" },
  md: { box: "p-2", gap: "gap-1", row: "mb-2", icon: "size-2.5", text: "text-[10px] leading-[12px]" },
  lg: { box: "p-3", gap: "gap-1.5", row: "mb-2.5", icon: "size-3", text: "text-[12px] leading-[15px]" },
};

export function ReferralCard({ size = "md" }: { size?: ReferralCardSize }) {
  const s = REFERRAL_CARD_SIZE[size];
  return (
    <div
      className={cn(
        "mx-2 mb-2 mt-auto rounded-card border-[0.5px] border-[#e3e6e8] bg-[#FFFFFF80]",
        s.box,
      )}
    >
      <div className={cn("flex", s.gap, s.row)}>
        <InfoIcon className={cn("mt-0.5 shrink-0", s.icon)} />
        <p className={cn("text-black/30", s.text)}>
          Resize the components, change the order, replace content & more.
        </p>
      </div>
      <Button variant="outlined">Start now</Button>
    </div>
  );
}
